import type { Role } from '@/entities/user';

export const deliveryRidersAccessRoles = ['admin'] as const satisfies readonly Role[];
